import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const i = {
  name: e.croatian,
  global: {
    undo: "Poništi",
    redo: "Ponovi",
    confirm: "Potvrdi",
    clear: "Čisto",
    more: "više",
    cancel: "Otkazati"
  },
  Popconfirm: {
    positiveText: "Potvrdi",
    negativeText: "Otkazati"
  },
  Cascader: {
    placeholder: "Molimo izaberite",
    loading: "Učitavam",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "yyyy-MM",
    dateFormat: "yyyy-MM-dd",
    dateTimeFormat: "yyyy-MM-dd HH:mm:ss",
    quarterFormat: "yyyy-qqq",
    clear: "Čisto",
    now: "Sada",
    confirm: "Potvrdi",
    selectTime: "Odaberite vrijeme",
    selectDate: "Odaberite Datum",
    datePlaceholder: "Odaberite Datum",
    datetimePlaceholder: "Odaberite datum i vrijeme",
    monthPlaceholder: "Odaberite mjesec",
    yearPlaceholder: "Odaberite godinu",
    quarterPlaceholder: "Odaberite Četvrtina",
    startDatePlaceholder: "Početni datum",
    endDatePlaceholder: "Datum završetka",
    startDatetimePlaceholder: "Datum i vrijeme početka",
    endDatetimePlaceholder: "Datum i vrijeme završetka",
    startMonthPlaceholder: "Početni mjesec",
    endMonthPlaceholder: "Kraj mjeseca",
    monthBeforeYear: !0,
    firstDayOfWeek: 6,
    today: "Danas"
  },
  DataTable: {
    checkTableAll: "Odaberite sve u tablici",
    uncheckTableAll: "Poništite odabir svih u tablici",
    confirm: "Potvrdi",
    clear: "Čisto",
    apply: "primijeniti",
    filters: "Filteri",
    sort: "Vrsta"
  },
  LegacyTransfer: {
    sourceTitle: "Izvor",
    targetTitle: "Cilj"
  },
  Transfer: {
    selectAll: "Odaberi sve",
    unselectAll: "Poništi odabir svih",
    clearAll: "Čisto"
  },
  Empty: {
    description: "Nema podataka"
  },
  Select: {
    placeholder: "Molimo izaberite"
  },
  TimePicker: {
    placeholder: "Odaberite vrijeme",
    positiveText: "u redu",
    negativeText: "Otkazati",
    now: "Sada"
  },
  Pagination: {
    goto: "Ići",
    selectionSuffix: "stranica",
    next: "Sljedeći",
    previous: "Prethodno"
  },
  DynamicTags: {
    add: "Dodati"
  },
  Log: {
    loading: "Učitavam"
  },
  Input: {
    placeholder: "Molimo unesite"
  },
  InputNumber: {
    placeholder: "Molimo unesite"
  },
  DynamicInput: {
    create: "Stvoriti"
  },
  ThemeEditor: {
    title: "Uređivač tema",
    clearAllVars: "Očisti sve varijable",
    clearSearch: "Očisti pretragu",
    filterCompName: "Naziv komponente filtra",
    filterVarName: "Naziv varijable filtra",
    import: "Uvoz",
    export: "Izvoz",
    restore: "Vrati na zadano"
  },
  Image: {
    tipPrevious: "Prethodna slika (←)",
    tipNext: "Sljedeća slika (→)",
    tipCounterclockwise: "Suprotno od kazaljke na satu",
    tipClockwise: "U smjeru kazaljke na satu",
    tipZoomOut: "Smanji",
    tipZoomIn: "Povećaj",
    tipClose: "Zatvori (Esc)",
    tipOriginalSize: "Zumirajte na izvornu veličinu"
  },
  SortFilter: {
    heading: "Sortiranje i filtriranje",
    sortHeading: "Poredaj po",
    newestFirst: "Prvo najnovije",
    oldestFirst: "Prvo najstariji",
    ascending: "Asc",
    descending: "Desc",
    aToZ: "A-Z",
    // Don't translate,
    zToA: "Z-A",
    // Don't translate,
    apply: "primijeniti",
    clear: "Čisto",
    cancel: "Otkazati",
    filters: "Filteri"
  },
  IconPicker: {
    noMatchingFound: "Nisu pronađeni odgovarajući rezultati"
  },
  Spacing: {
    margin: "Margina",
    padding: "ispune",
    reset: "Poništavanje",
    errorMsg: "Pružena vrijednost nije valjana."
  },
  BrandColorPicker: {
    brandColors: "Boje marke",
    noBrandColors: "Još niste dodali nijednu boju marke.",
    getStarted: "Započni",
    add: "Dodaj",
    default: "Zadano"
  }
};
export {
  i as hr
};
